import React, { Fragment, useState } from "react";
import Alert from "../../layout/Alert";
import DeviceFactoryFirmware from "./FactoryFirmware";
import DeviceFotaFirmware from "./FotaFirmware";
import FirmwareDistribution from "./FirmwareDistribution";
import { Box } from "@mui/material";
import ResponsiveContentWrapper from "../../layout/ResponsiveContentWrapper";
import AppTabs from "../../Common/Tabs/AppTabs";
import "./DeviceFirmware.css";

const FIRMWARE_TABS = [
    { label: "Firmware Distribution" },
    { label: "Factory Firmware" },
    { label: "FOTA Firmware" },
];

const DeviceFirmware = ({ wrapperClass }) => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <Fragment>
            <ResponsiveContentWrapper className={wrapperClass || ""}>
                <Alert />
                <Box sx={{ width: "100%", minWidth: 0, boxSizing: "border-box" }}>
                    <AppTabs
                        value={activeTab}
                        onChange={(e, newValue) => setActiveTab(newValue)}
                        tabs={FIRMWARE_TABS}
                        variant="scrollable"
                        scrollButtons="auto"
                        tabMinWidth="auto"
                        appearance="neutral"
                    />
                    {activeTab === 0 && (
                        <Box sx={{ mt: 0 }}>
                            <FirmwareDistribution />
                        </Box>
                    )}
                    {activeTab === 1 && (
                        <Box sx={{ mt: 0 }}>
                            <DeviceFactoryFirmware />
                        </Box>
                    )}
                    {activeTab === 2 && (
                        <Box sx={{ mt: 0 }}>
                            <DeviceFotaFirmware />
                        </Box>
                    )}
                </Box>
            </ResponsiveContentWrapper>
        </Fragment>
    );
};

export default DeviceFirmware

